export default __webpack_public_path__ + "static/article-5-reshenia-b3c1cdaae0470479ebff722a474ccb38.jpg";